// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 14 ? "bh-helper-instance" : chunkId) + "-legacy." + {"14":"7f8191fa","36":"4a593677","94":"93d4fb7f","150":"c70239c0","154":"348dc1cd","493":"5d07fa5a","594":"4ce17b21","902":"75cfb2d5"}[chunkId] + ".js";
};